import React from 'react'
import LocalizedSpan from './LocalizedSpan'

type Props = {
  children: string
  style?: React.CSSProperties
}

const LocalizedChip: React.FC<Props> = ({ children, style }) => {
  return (
    <LocalizedSpan
      style={{
        borderRadius: '999px',
        background: 'lightgrey',
        padding: '8px',
        ...style,
      }}
    >
      {children}
    </LocalizedSpan>
  )
}

export default LocalizedChip
